// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"G1-z","colorTextValue":"H1-z","swatches":"I1-z","collapseLink":"J1-z","isCollapsed":"K1-z","dropdown":"L1-z","disabled":"M1-z"};